// src/store/lang.js
// Language preference store.
// All components import { useLang } from '@store/lang'
// and use the t() helper for translated strings.

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { t as translate } from '@data/translations';

export const useLangStore = create(
  persist(
    (set, get) => ({
      lang: 'en',   // 'en' | 'es'

      setLang: (lang) => set({ lang }),
      toggle:  ()     => set((s) => ({ lang: s.lang === 'en' ? 'es' : 'en' })),

      // Shorthand translation helper bound to current lang
      t: (key) => translate(key, get().lang),
    }),
    {
      name:    'na-lang',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
